<template>
    <div class="ep-drawer">
        <div :class="['drawer', { 'drawer-open': value }]">
            <!-- Drawer content -->
            <div class="drawer-content" v-if="value">
                <!-- Header Section -->
                <div class="top-section">
                    <div class="header-row">
                        <i @click.stop="toggle" class="fa-regular fa-arrow-right-from-line fa-xl hover-black"></i>

                        <h4>{{ header }}</h4>
                    </div>

                    <slot name="headerSection"></slot>

                </div>

                <!-- Default slot for main content -->
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value: false,
                openBeforeResize: false,
                isSmallScreen: window.innerWidth <= this.maxWidth,
            };
        },
        props: {
            header: {
                type: String,
                default: ''
            },

            drawerPage: {
                type: String,
                required: true
            },

            maxWidth: {
                type: Number,
                default: 991,
            },
        },
        mounted() {
            this.value = localStorage.getItem(`drawerState::${this.drawerPage}`) === 'true';
            this.$event_bus.$on('toggle-drawer', this.toggle);
            window.addEventListener('resize', this.handleResize);
            this.emitToggleMargin();
        },
        unmounted() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            toggle() {
                this.value = !this.value;
                localStorage.setItem(`drawerState::${this.drawerPage}`, this.value);
                this.emitToggleMargin();
	            this.$event_bus.$emit('calendarDrawerState', this.value);
            },
            handleResize() {
                this.isSmallScreen = window.innerWidth <= this.maxWidth;

                if (this.isSmallScreen && this.value) {
                    this.openBeforeResize = true;
                    this.toggle();
                } else if (!this.isSmallScreen && this.openBeforeResize) {
                    this.openBeforeResize = false;
                    this.toggle();
                }
            },
            emitToggleMargin() {
                this.$nextTick(() => {
                    this.$event_bus.$emit('toggle-margin', this.value);
                    this.$emit('input', this.value);
                });
            },
        },
    };
</script>

